export default function(editor, opts) {
    const blockManager = editor.BlockManager;
    const components = editor.DomComponents;
    const defaultType = components.getType('default');
    const defaultModel = defaultType.model;
    const defaultView = defaultType.view;
    const textType = components.getType('text');
    
    const { category, blocks, stylePrefix, flexGrid, rowHeight, addBasicStyle } = opts


    const privateCls = [".editor__container", ".editor__block", ".accordion", ".accordion__radio", ".accordion__Label", ".accordion__content", ".page",".page__container",".page__heading",".page__content",".breadcrumbs",".breadcrumbs__link",".breadcrumb__divider", ".breadcrumbs__text"];
    //editor.on("selector:add", selector => privateCls.indexOf(selector.getFullName()) >= 0 && selector.set("private", 1))


    const commonBlockProps = {category, select: true }

    const margin_defaults = "margin-top:0px;margin-bottom:0px;margin-left:0px;margin-right:0px;padding-top:0px;padding-bottom:0px;padding-left:0px;padding-right:0px;"


    blockManager.add("section", {
        ...commonBlockProps,
        label: "Section",
        media: `<svg viewBox="0 0 24 24"><path fill="currentColor" d="M2 20h20V4H2v16Zm-1 0V4a1 1 0 0 1 1-1h20a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1Z"/></svg>`,
        content: `<div class="editor__container"
                        style="position:relative; display:flex; flex:1 1 auto; max-width:100%; justify-content:flex-start; align-items:center;"
                        data-gjs-stylable-require="['display', 'max-width', 'height', 'justify-content', 'align-items', 'flex', 'flex-wrap', 'margin', 'padding', 'backgroundcolour', 'border', 'border-radius' ]"
                        data-gjs-name="Section"
                        data-gjs-droppable="true"></div>`
    })


    blockManager.add("page-container", {
        ...commonBlockProps,
        label: "Page Container",
        media: `<svg viewBox="0 0 22.3 18.5"><path fill="currentColor" d="M1.1,17.2h20v-16h-20V17.2z M0.1,17.2v-16c0-0.6,0.4-1,1-1h20c0.6,0,1,0.4,1,1v16c0,0.6-0.4,1-1,1h-20\tC0.6,18.2,0.1,17.8,0.1,17.2z"/><rect fill="currentColor" x="5" y="0.6" width="1" height="17.2"/><rect fill="currentColor" x="16.7" y="0.6" width="1" height="17.2"/><rect fill="currentColor" x="10.9" y="-2.2" transform="matrix(-1.836970e-16 1 -1 -1.836970e-16 14.8638 -7.9226)" width="1" height="11.3"/></svg>
`,
        content: `
<div class="page" data-gjs-name="Page Container" data-gjs-selectable="false">
    <div class="breadcrumbs" data-gjs-name="Breadcrumbs" data-gjs-selectable="false" >
      <a class="breadcrumbs__link" href="/"  data-gjs-name="Breadcrumb Link" data-gjs-selectable="false" >Home</a>
      <div class="breadcrumb__divider" data-gjs-name="Breadcrumb Divider"></div>
      <div class="breadcrumbs__text" data-gjs-name="Breadcrumb Text">Some Heading</div>
    </div>
    <div class="page__container" data-gjs-name="Page Body" data-gjs-selectable="false">
      <h1 class="page__heading"  data-gjs-name="Page Heading">Some Heading</h1>
      <div class="page__content" data-gjs-droppable="true" data-gjs-name="Page Content" data-gjs-selectable="false">
  
      </div>
    </div>
  </div>
`
    });


    blockManager.add("overlay", {
        ...commonBlockProps,
        label: "Overlay",
        media: `<svg viewBox="0 0 27.3 21.2"><path fill="currentColor" d="M5.5,17.3H2v-16h20v2.3l1,0.2V1.3c0-0.6-0.4-1-1-1H2c-0.6,0-1,0.4-1,1v16c0,0.6,0.4,1,1,1h3.5L5.5,17.3z"/><path fill="currentColor" d="M6,20h20V4H6V20z M5,20V4c0-0.6,0.4-1,1-1h20c0.6,0,1,0.4,1,1v16c0,0.6-0.4,1-1,1H6C5.4,21,5,20.6,5,20z"/></svg>`,
        content: `<div class="editor__overlay"
                        style="display:block; max-width:100%; max-height:100%; position:absolute;" 
                        data-gjs-stylable-require="['display', 'top', 'bottom','left','right', 'z-index', 'padding', 'backgroundcolour', 'border', 'border-radius']"
                        data-gjs-name="Overlay"
                        data-gjs-droppable="true"></div>`
    })

    blockManager.add("image", {
        ...commonBlockProps,
        activate: true,
        label: opts.labelImage,
        media: `<svg viewBox="0 0 24 24"><path fill="currentColor" d="M21,3H3C2,3 1,4 1,5V19A2,2 0 0,0 3,21H21C22,21 23,20 23,19V5C23,4 22,3 21,3M5,17L8.5,12.5L11,15.5L14.5,11L19,17H5Z" /></svg>`,
        content: {
            type: "image",
            style: { display:'block', 'max-width':'100%;', 'min-width':0 },
            'stylable-require': "['max-width', 'margin']",
        }
    });


    editor.Components.addType('custom-video', {
        model: {
            defaults: {
                tagName: 'video',
                resizable: true,
                droppable: false,
                traits: [
                    {
                        type: 'text',
                        label: 'Vieo URL',
                        name: 'src',
                    },
                    {
                        type: 'checkbox',
                        label: 'controls',
                        name: 'controls',
                    },
                    {
                        type: 'checkbox',
                        label: 'autoplay',
                        name: 'autoplay',
                        default: true
                    },
                    {
                        type: 'checkbox',
                        label: 'loop',
                        name: 'loop',
                        default: true
                    },
                    {
                        type: 'checkbox',
                        label: 'muted',
                        name: 'muted',
                        default: true
                    }
                ],
            },

            init() {
                this.listenTo(this, 'change:src', this.updateSourceTag);
            },

            updateSourceTag() { console.log("updateSourceTag")
                const src = this.get('src');

                console.log("updateSourceTag", src)

                const sourceTag = this.findType('source')[0];

                console.log("sourceTag", sourceTag);

                const video_source = this.attributes.components.models.find( u => u.attributes.tagName === "source" );
                video_source.set({ attributes: { src: src, type: "video/mp4" }});

                //if (sourceTag && src) {
                  //  sourceTag.addAttributes({ src });
                    this.getEl().load(); // Reload the video element to reflect the change
                //}
            },

            // Handle click event to open Asset Manager
            events: {
                dblclick: 'openAssetManager',
            },

            openAssetManager() { console.log("openAssetManager")
                const assetManager = editor.AssetManager;
                const model = this;
               // const video_source = model.attributes.components.models.find( u => u.attributes.tagName === "source" );
               // console.log("video_source", video_source);
                assetManager.open({
                    types: ['video'],
                    select(asset) {
                        const video_url = asset.get('name');
                        model.set('src', video_url);
                        //model.set({ attributes: { src: videoUrl }});
                        //video_source.set('src', src);
                        //video_source.set({ attributes: { src: videoUrl, type: "video/mp4" }});

                        assetManager.close();
                    }
                });
            },
        },

        view: {
            onRender() {
                const src = this.model.get('src');
                const sourceTag = this.model.findType('source')[0];

                if (sourceTag && src) {
                    sourceTag.addAttributes({ src });
                }

                this.el.addEventListener('dblclick', () => {
                    this.model.openAssetManager();
                });
            },
        },
    });


    blockManager.add('custom-video-block', {
        ...commonBlockProps,
        label: 'Video',
        media: `<svg viewBox="0 0 24 24"><path fill="currentColor" d="M10,15L15.19,12L10,9V15M21.56,7.17C21.69,7.64 21.78,8.27 21.84,9.07C21.91,9.87 21.94,10.56 21.94,11.16L22,12C22,14.19 21.84,15.8 21.56,16.83C21.31,17.73 20.73,18.31 19.83,18.56C19.36,18.69 18.5,18.78 17.18,18.84C15.88,18.91 14.69,18.94 13.59,18.94L12,19C7.81,19 5.2,18.84 4.17,18.56C3.27,18.31 2.69,17.73 2.44,16.83C2.31,16.36 2.22,15.73 2.16,14.93C2.09,14.13 2.06,13.44 2.06,12.84L2,12C2,9.81 2.16,8.2 2.44,7.17C2.69,6.27 3.27,5.69 4.17,5.44C4.64,5.31 5.5,5.22 6.82,5.16C8.12,5.09 9.31,5.06 10.41,5.06L12,5C16.19,5 18.8,5.16 19.83,5.44C20.73,5.69 21.31,6.27 21.56,7.17Z" /></svg>`,
        content: {
            type: 'custom-video',
            tagName: 'video',
            components: [
                {
                    tagName: 'source',
                    attributes: { src: '', type: 'video/mp4' },
                },
            ],
            style: { height: 'auto', width: '100%', 'min-height': '100px', background: "#333333" },
        }
    });


/*
    const openAssetSelector = (model) => {



        //const video = model.attributes.components.models.find( u => u.attributes.tagName === "video" );
       // const video_source = video.attributes.components.models.find( u => u.attributes.tagName === "source" );



        editor.AssetManager.open({
            types: ['video'], // Only show video assets in the manager
            onSelect: function (asset) {


               // const main_view = model.view.el;
               // const video_view = main_view.getElementsByTagName("video")[0];

                //console.log("openAssetSelector", main_view)
                //console.log("view", video_view)

                const videoUrl = asset.get('name')
                console.log(videoUrl)
                //block.innerHTML = `<video src="${videoUrl}" controls></video>`;

                console.log("model.attributes.components.models", model.attributes.components.models)

                const video = model.attributes.components.models.find( u => u.attributes.tagName === "video" );
                const video_source = video.attributes.components.models.find( u => u.attributes.tagName === "source" );
                video_source.set({ attributes: { src: videoUrl, type: "video/mp4" }});

               // video_view.innerHTML = `<source src="${videoUrl}" type="video/mp4">`

                console.log("model.view.el", model.view.el)

                editor.AssetManager.close();
            }
        });
    };

    editor.Components.addType('videoplayer', {
        extend: 'text',
        isComponent: el => { return (el.classList && el.classList.contains("editor__video-container")) },
        model: {
            defaults: {
                //  traits: [{ name: 'for' }],
            },
        },
        view: {
            //init() {
                //console.log("init video player")
               // openAssetSelector(this.model);
              //  this.onRender();
            //},
            onRender() {
                if (this.el) {
                    this.el.addEventListener('click', () => {

                        //console.log("this.el", this.el);
                        //console.log('Video player clicked!', this.model);
                       // openAssetSelector(this.model);

                       //console.log("ii", this.el.querySelector(".editor__video"));

                        //this.el.querySelector(".editor__video").play();
                    });
                }
            }
        }
    });

    blockManager.add('videoplayer', {
        ...commonBlockProps,
        type: 'videoplayer',
        label: 'Video Player',
        media: `<svg viewBox="0 0 24 24"><path fill="currentColor" d="M10,15L15.19,12L10,9V15M21.56,7.17C21.69,7.64 21.78,8.27 21.84,9.07C21.91,9.87 21.94,10.56 21.94,11.16L22,12C22,14.19 21.84,15.8 21.56,16.83C21.31,17.73 20.73,18.31 19.83,18.56C19.36,18.69 18.5,18.78 17.18,18.84C15.88,18.91 14.69,18.94 13.59,18.94L12,19C7.81,19 5.2,18.84 4.17,18.56C3.27,18.31 2.69,17.73 2.44,16.83C2.31,16.36 2.22,15.73 2.16,14.93C2.09,14.13 2.06,13.44 2.06,12.84L2,12C2,9.81 2.16,8.2 2.44,7.17C2.69,6.27 3.27,5.69 4.17,5.44C4.64,5.31 5.5,5.22 6.82,5.16C8.12,5.09 9.31,5.06 10.41,5.06L12,5C16.19,5 18.8,5.16 19.83,5.44C20.73,5.69 21.31,6.27 21.56,7.17Z" /></svg>`,
        content: `<div class="editor__video-container"
                        style="display:block; max-width:100%;" 
                        data-gjs-stylable-require="['display', 'max-width', 'flex', 'flex-wrap', 'margin' ]"
                        data-gjs-name="Video Container"
                        data-gjs-droppable="true">
                      <video data-gjs-type="video" class="editor__video" muted autoplay >
                           <source type="video/mp4">
                      </video> 
                  </div>`
    });*/

       /* script: function ()  { console.log("cu")
            const block = this;
            block.addEventListener('click', () => {
                const am = editor.AssetManager;
                am.open({
                    types: ['video'], // Only show video assets in the manager
                    onSelect: function (asset) {
                        const videoUrl = asset.get('src');
                        block.innerHTML = `<video src="${videoUrl}" controls></video>`;
                    }
                });
            });
        }*/




/*
    blockManager.add("video", {
        ...commonBlockProps,
        label: opts.labelVideo,
        media: `<svg viewBox="0 0 24 24">
        <path fill="currentColor" d="M10,15L15.19,12L10,9V15M21.56,7.17C21.69,7.64 21.78,8.27 21.84,9.07C21.91,9.87 21.94,10.56 21.94,11.16L22,12C22,14.19 21.84,15.8 21.56,16.83C21.31,17.73 20.73,18.31 19.83,18.56C19.36,18.69 18.5,18.78 17.18,18.84C15.88,18.91 14.69,18.94 13.59,18.94L12,19C7.81,19 5.2,18.84 4.17,18.56C3.27,18.31 2.69,17.73 2.44,16.83C2.31,16.36 2.22,15.73 2.16,14.93C2.09,14.13 2.06,13.44 2.06,12.84L2,12C2,9.81 2.16,8.2 2.44,7.17C2.69,6.27 3.27,5.69 4.17,5.44C4.64,5.31 5.5,5.22 6.82,5.16C8.12,5.09 9.31,5.06 10.41,5.06L12,5C16.19,5 18.8,5.16 19.83,5.44C20.73,5.69 21.31,6.27 21.56,7.17Z" />
      </svg>`,
        content: {
            type: "video",
            src: "img/video2.weblockManager",
            style: {
                height: "350px",
                width: "615px"
            }
        }
    })*/


    blockManager.add("text", {
        ...commonBlockProps,
        activate: true,
        label: "Text",
        media: `<svg viewBox="0 0 24 24"><path fill="currentColor" d="M18.5,4L19.66,8.35L18.7,8.61C18.25,7.74 17.79,6.87 17.26,6.43C16.73,6 16.11,6 15.5,6H13V16.5C13,17 13,17.5 13.33,17.75C13.67,18 14.33,18 15,18V19H9V18C9.67,18 10.33,18 10.67,17.75C11,17.5 11,17 11,16.5V6H8.5C7.89,6 7.27,6 6.74,6.43C6.21,6.87 5.75,7.74 5.3,8.61L4.34,8.35L5.5,4H18.5Z" /></svg>`,
        content: {
            type: "text",
            name: "Text",
            class: "editor__text",
            content: "Insert your text here",
            style: { 'font-family': "'Poppins', sans-serif", 'font-size': '14px;', 'letter-spacing': '0.05em', 'line-height': 1.4, 'color':'#000000',   },
            'stylable-require': "['margin', 'font-family', 'font-size', 'font-weight', 'letter-spacing', 'color', 'line-height', 'text-align'"
        }
    });


    blockManager.add("button", {
        ...commonBlockProps,
        activate: true,
        label: "Button",
        media: `<svg viewBox="0 0 32 20"><path fill="currentColor" d="M22.6,15H8.8c-2.5,0-4.6-2.1-4.6-4.6s2.1-4.6,4.6-4.6h13.8c2.5,0,4.6,2.1,4.6,4.6S25.1,15,22.6,15z M8.8,6.8
\t\tc-2,0-3.6,1.6-3.6,3.6c0,2,1.6,3.6,3.6,3.6h13.8c2,0,3.6-1.6,3.6-3.6c0-2-1.6-3.6-3.6-3.6H8.8z"/></svg>`,
        content: {
            type: "link",
            name: "Button",
            class: "editor__button",
            content: "Button Text",
            style: { 'font-family': "'Poppins', sans-serif", 'padding': '8px 24px 8px 24px', 'font-weight':500, 'font-size': '11px;', 'text-transform': 'uppercase', 'white-space': 'nowrap', 'letter-spacing': '0.1em', 'line-height': 1, 'color':'#ffffff', 'background-color':'#000000', 'border-radius':'20px' },
            'stylable-require': "['margin', 'padding' 'font-family', 'font-size', 'font-weight', 'letter-spacing', 'color', 'background-color', 'border-radius', 'line-height', 'text-align'"
        }
    });

    editor.Components.addType('accordion', {
        extend: 'text',
        isComponent: el => { return (el.classList && el.classList.contains("accordion")) },
        model: {
            defaults: {
              //  traits: [{ name: 'for' }],
            },
        },
        view: {
            init() {
                const new_id = "accordion_" + ( new Date().getTime());
                const input = this.model.attributes.components.models.find( u => u.attributes.tagName === "input" );
                const label = this.model.attributes.components.models.find( u => u.attributes.tagName === "label" );
                input.set({ attributes: { id: new_id, type: "checkbox" }});
                label.set({ attributes: { for: new_id }});
            }
        }
    });



    blockManager.add("accordion", {
        ...commonBlockProps,
        type: "accordion",
        label: "Accordion",
        media: `<svg viewBox="0 0 27.3 21.2"><rect fill="currentColor" x="0" y="2" width="24" height="0.3" /><rect fill="currentColor" x="0" y="21" width="24" height="0.3" /><path fill="currentColor" d="M18.5,4L19.66,8.35L18.7,8.61C18.25,7.74 17.79,6.87 17.26,6.43C16.73,6 16.11,6 15.5,6H13V16.5C13,17 13,17.5 13.33,17.75C13.67,18 14.33,18 15,18V19H9V18C9.67,18 10.33,18 10.67,17.75C11,17.5 11,17 11,16.5V6H8.5C7.89,6 7.27,6 6.74,6.43C6.21,6.87 5.75,7.74 5.3,8.61L4.34,8.35L5.5,4H18.5Z" /></svg>`,
        content: `<div class="accordion" data-gjs-name="Accordion" v-accordion>
            <input class="accordion__radio" type="checkbox" checked="checked" data-gjs-name="Accordion Trigger" data-gjs-selectable="false" />
            <label class="accordion__Label" data-gjs-name="Accordion Content"  data-gjs-selectable="false" data-gjs-draggable="false" data-gjs-removable="false" >Accordion Heading</label>
            <div class="accordion__content" data-accordion-content  data-gjs-name="Accordion Content" data-gjs-selectable="false" data-gjs-droppable="true" data-gjs-draggable="false" data-gjs-removable="false" >Accordion Content</div>
         </div>`
    });


    blockManager.add("opportunities", {
        ...commonBlockProps,
        type: "opportunities",
        label: "Opportunities",
        media: `<svg viewBox="0 0 24 24">
<path d="M0.7,15.7h6.7V6.6H0.7V15.7z M0.4,15.7V6.6C0.4,6.3,0.5,6,0.7,6h6.7c0.2,0,0.3,0.3,0.3,0.6v9.1c0,0.3-0.1,0.6-0.3,0.6H0.7
\tC0.5,16.3,0.4,16.1,0.4,15.7z"/>
<path d="M8.7,15.7h6.7V6.6H8.7V15.7z M8.3,15.7V6.6C8.3,6.3,8.5,6,8.7,6h6.7c0.2,0,0.3,0.3,0.3,0.6v9.1c0,0.3-0.1,0.6-0.3,0.6H8.7
\tC8.5,16.3,8.3,16.1,8.3,15.7z"/>
<path d="M16.6,15.7h6.7V6.6h-6.7V15.7z M16.3,15.7V6.6c0-0.3,0.1-0.6,0.3-0.6h6.7c0.2,0,0.3,0.3,0.3,0.6v9.1c0,0.3-0.1,0.6-0.3,0.6
\th-6.7C16.4,16.3,16.3,16.1,16.3,15.7z"/>
<rect x="0.8" y="16.7" width="4.7" height="0.4"/>
<rect x="0.8" y="17.5" width="2.5" height="0.4"/>
<rect x="8.7" y="16.7" width="4.7" height="0.4"/>
<rect x="8.7" y="17.5" width="2.5" height="0.4"/>
<rect x="16.6" y="16.7" width="4.7" height="0.4"/>
<rect x="16.6" y="17.5" width="2.5" height="0.4"/>
</svg>`,
        content: `<opportunities data-gjs-name="Opportunities"  data-gjs-stylable-require="['max-width', 'margin']"></opportunities>`
    });


    editor.Components.addType('calendly', {
        extend: 'text',
        isComponent: el => { return (el.tagName && el.tagName == "CALENDLY") },
        model: {
            defaults: {
              name: 'calendly',
              calendly_url: "https://calendly.com/anthony-1041/justcuts_franchise_opportunities_phonecall",
              traits: [{ type: 'text', label: 'Calendly URL',  name: 'calendly_url',  changeProp: 1 }],
            },
        },
        view: {
            init() {
                console.log('ss',this.model.attributes.calendly_url);
                this.model.set({attributes: { calendly_url: this.model.attributes.calendly_url }});
                this.listenTo(this.model, 'change:calendly_url', (event) => {
                    this.model.set({attributes: {calendly_url: event.changed.calendly_url }});
                });
            }
        }
    });

    blockManager.add("calendly", {
        ...commonBlockProps,
        type: "calendly",
        label: "Calendly",
        media: `<svg viewBox="0 0 117.79 122.88"><title>date-reminder</title><path d="M89.34,55a22.54,22.54,0,0,1,2.6.84,24.94,24.94,0,0,1,3.55,1.76l.13.09a23.5,23.5,0,0,1,3,2.2,23.15,23.15,0,0,1,2.73,2.78h0a23,23,0,0,1,2.22,3.19,26,26,0,0,1,1.68,3.54h0a22.66,22.66,0,0,1,1.07,3.87,23,23,0,0,1,.36,4.09v4.43c0,1.41,0,2.79,0,4.14h0a32.3,32.3,0,0,0,.24,3.67,29.64,29.64,0,0,0,.65,3.52h0a17.77,17.77,0,0,0,1.15,3.21,20.85,20.85,0,0,0,1.8,3.11h0a18.94,18.94,0,0,0,2.63,2.94,30.26,30.26,0,0,0,3.78,2.94,1.79,1.79,0,0,1-1,3.28H51.14a1.8,1.8,0,0,1-.93-3.34A33.86,33.86,0,0,0,54,102.38a18.05,18.05,0,0,0,2.61-3l.06-.09a21.54,21.54,0,0,0,1.74-3,18.91,18.91,0,0,0,1.17-3.23s0,0,0-.07a25,25,0,0,0,.63-3.4,29.64,29.64,0,0,0,.23-3.7V77.39a23.46,23.46,0,0,1,.36-4.09,22.55,22.55,0,0,1,1.08-3.89,25.4,25.4,0,0,1,1.7-3.57,22.79,22.79,0,0,1,2.24-3.21h0a23.21,23.21,0,0,1,2.74-2.78,23.68,23.68,0,0,1,3.19-2.29,22.83,22.83,0,0,1,3.59-1.74A20.91,20.91,0,0,1,78,55a5.45,5.45,0,0,1,1.59-2.63,6.74,6.74,0,0,1,8.17,0A5.35,5.35,0,0,1,89.34,55ZM64.28,3.74c0-2.05,2-3.74,4.57-3.74s4.56,1.67,4.56,3.74V20.09c0,2.05-2,3.74-4.56,3.74s-4.57-1.67-4.57-3.74V3.74Zm-51,68.18H23.69a1.21,1.21,0,0,1,1.21,1.21v7.72a1.21,1.21,0,0,1-1.21,1.21H13.24A1.21,1.21,0,0,1,12,80.85V73.13a1.21,1.21,0,0,1,1.21-1.21Zm40-22H63.7a1.22,1.22,0,0,1,.83.33,37.23,37.23,0,0,0-10.47,9.81h-.81a1.2,1.2,0,0,1-1.2-1.2V51.13a1.21,1.21,0,0,1,1.2-1.21Zm-20,0H43.7a1.2,1.2,0,0,1,1.2,1.2v7.73a1.2,1.2,0,0,1-1.2,1.2H33.25A1.21,1.21,0,0,1,32,58.85V51.12a1.21,1.21,0,0,1,1.21-1.2Zm-20,0H23.69a1.21,1.21,0,0,1,1.21,1.2v7.73a1.21,1.21,0,0,1-1.21,1.2H13.24A1.21,1.21,0,0,1,12,58.85V51.12a1.21,1.21,0,0,1,1.21-1.2Zm20,22H43.7a1.21,1.21,0,0,1,1.2,1.21v7.72a1.21,1.21,0,0,1-1.2,1.21H33.25A1.21,1.21,0,0,1,32,80.85V73.13a1.21,1.21,0,0,1,1.21-1.21ZM23.34,3.74c0-2.05,2-3.74,4.56-3.74s4.56,1.67,4.56,3.74V20.09c0,2.05-2,3.74-4.56,3.74s-4.56-1.67-4.56-3.74V3.74ZM5,35.74H91.84V16.93a2.23,2.23,0,0,0-.68-1.62,2.28,2.28,0,0,0-1.62-.68H81.22a2.53,2.53,0,0,1,0-5.05h8.32A7.37,7.37,0,0,1,96.91,17V46.83a37.94,37.94,0,0,0-5.13-1.37V40.79H5V89.54a2.26,2.26,0,0,0,.67,1.62,2.32,2.32,0,0,0,1.63.68H48.57a37,37,0,0,0,1.77,5.1h-43A7.36,7.36,0,0,1,0,89.58V17A7.37,7.37,0,0,1,7.36,9.58h8.89a2.53,2.53,0,0,1,0,5.05H7.36a2.27,2.27,0,0,0-1.62.68,2.32,2.32,0,0,0-.67,1.62V35.75H5ZM39.74,14.62a2.53,2.53,0,0,1,0-5H56.69a2.53,2.53,0,1,1,0,5Zm54,99.9a10.08,10.08,0,0,1-1.18,3.23,10.38,10.38,0,0,1-2.3,2.72,10.08,10.08,0,0,1-3.09,1.81,10.46,10.46,0,0,1-3.55.6,10.62,10.62,0,0,1-3.55-.6,10.27,10.27,0,0,1-6.59-7.87,1.1,1.1,0,0,1,.89-1.27l.19,0H92.64a1.1,1.1,0,0,1,1.1,1.1,1,1,0,0,1,0,.3Zm-3.38-54a18.73,18.73,0,0,0-2.91-.88,1.72,1.72,0,0,1-1.48-1.49,2.45,2.45,0,0,0-.64-1.58,2.5,2.5,0,0,0-1.63-.46,2.42,2.42,0,0,0-1.61.43,2.45,2.45,0,0,0-.63,1.59h0A1.71,1.71,0,0,1,80,59.65a18,18,0,0,0-3.1.87,18.51,18.51,0,0,0-2.87,1.39,19.72,19.72,0,0,0-2.57,1.85A18.89,18.89,0,0,0,69.26,66h0a18.79,18.79,0,0,0-1.8,2.6,19.83,19.83,0,0,0-1.38,2.9,17.49,17.49,0,0,0-.87,3.1,18.36,18.36,0,0,0-.28,3.3V86a32.15,32.15,0,0,1-.24,4,31.15,31.15,0,0,1-.7,3.69s0,0,0,.08a21.93,21.93,0,0,1-1.33,3.65,24.27,24.27,0,0,1-1.93,3.38.61.61,0,0,0-.07.1,21.11,21.11,0,0,1-3,3.37l0,0h51.92a21.17,21.17,0,0,1-3-3.34h0a24,24,0,0,1-2-3.47,21,21,0,0,1-1.33-3.67h0a29.31,29.31,0,0,1-.7-3.78,34.61,34.61,0,0,1-.24-3.9h0c0-1.27,0-2.6,0-4,0-2.56,0-4,0-4.23a17.93,17.93,0,0,0-.29-3.3,16.8,16.8,0,0,0-.85-3.07h0a19,19,0,0,0-3.15-5.47h0a18.53,18.53,0,0,0-2.2-2.23A19.45,19.45,0,0,0,93.29,62L93.18,62a22.41,22.41,0,0,0-2.87-1.41Z"/></svg>`,
        content: `<calendly data-gjs-name="Calendly"  data-gjs-stylable-require="['max-width', 'margin']"></calendly>`
    });

    /*

        const clsRow = `${stylePrefix}row`
    const clsCell = `${stylePrefix}cell`
    const styleRow =
        `
    .${clsRow} {
      display: flex;
      justify-content: flex-start;
      align-items: stretch;
      flex-wrap: nowrap;
      padding: 10px;
    }
    @media (max-width: 768px) {
      .${clsRow} {
        flex-wrap: wrap;
      }
    }`
    const styleClm = `
    .${clsCell} {
      min-height: ${rowHeight}px;
      flex-grow: 1;
      flex-basis: 100%;
    }`;


    const step = 0.2
    const minDim = 1
    const currentUnit = 1
    const resizerBtm = { tl: 0, tc: 0, tr: 0, cl: 0, cr: 0, bl: 0, br: 0, minDim }
    const resizerRight = { ...resizerBtm, cr: 1, bc: 0, currentUnit, minDim, step }
    resizerRight.keyWidth = "flex-basis"


    const rowAttr = {
        class: clsRow,
        "data-gjs-droppable": `.${clsCell}`,
        "data-gjs-name": "Row"
    } // "data-gjs-resizable": resizerBtm,

    const colAttr = {
        class: clsCell,
        "data-gjs-draggable": `.${clsRow}`,
        "data-gjs-name": "Cell",
        "data-gjs-unstylable": ["width"],
        "data-gjs-stylable-require": ["flex-basis"]
    } //"data-gjs-resizable": resizerRight,



    const attrsToString = attrs => {
        const result = []

        for (let key in attrs) {
            let value = attrs[key]
            const toParse = value instanceof Array || value instanceof Object
            value = toParse ? JSON.stringify(value) : value
            result.push(`${key}=${toParse ? `'${value}'` : `'${value}'`}`)
        }

        return result.length ? ` ${result.join(" ")}` : ""
    }

    const attrsRow = attrsToString(rowAttr)
    const attrsCell = attrsToString(colAttr)

    blockManager.add("column1", {
        ...commonBlockProps,
        label: opts.labelColumn1,
        media: `<svg viewBox="0 0 24 24">
        <path fill="currentColor" d="M2 20h20V4H2v16Zm-1 0V4a1 1 0 0 1 1-1h20a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1Z"/>
      </svg>`,
        content: `<div ${attrsRow}>
        <div ${attrsCell}></div>
      </div>
      ${
            addBasicStyle
                ? `<style>
          ${styleRow}
          ${styleClm}
        </style>`
                : ""
        }`
    })

    blockManager.add("link", {
        ...commonBlockProps,
        label: opts.labelLink,
        media: `<svg viewBox="0 0 24 24">
        <path fill="currentColor" d="M3.9,12C3.9,10.29 5.29,8.9 7,8.9H11V7H7A5,5 0 0,0 2,12A5,5 0 0,0 7,17H11V15.1H7C5.29,15.1 3.9,13.71 3.9,12M8,13H16V11H8V13M17,7H13V8.9H17C18.71,8.9 20.1,10.29 20.1,12C20.1,13.71 18.71,15.1 17,15.1H13V17H17A5,5 0 0,0 22,12A5,5 0 0,0 17,7Z" />
      </svg>`,
        content: {
            type: "link",
            content: "Link",
            style: { color: "#d983a6" }
        }
    })

    blockManager.add("map", {
        ...commonBlockProps,
        label: opts.labelMap,
        media: `<svg viewBox="0 0 24 24">
        <path fill="currentColor" d="M20.5,3L20.34,3.03L15,5.1L9,3L3.36,4.9C3.15,4.97 3,5.15 3,5.38V20.5A0.5,0.5 0 0,0 3.5,21L3.66,20.97L9,18.9L15,21L20.64,19.1C20.85,19.03 21,18.85 21,18.62V3.5A0.5,0.5 0 0,0 20.5,3M10,5.47L14,6.87V18.53L10,17.13V5.47M5,6.46L8,5.45V17.15L5,18.31V6.46M19,17.54L16,18.55V6.86L19,5.7V17.54Z" />
      </svg>`,
        content: {
            type: "map",
            style: { height: "350px" }
        }
    })*/
}
